<template>
    <img src="../../../../assets/image/live/gift.png" class="gift" @click="showgift"/>
</template>

<script>
export default {
  props: {
  },
  data () {
      return {}
  },
  methods: {
    showgift () {
      this.$emit('showGift')
    }
  },
  computed: {}
}
</script>
<style lang="scss" scoped>
    .gift {
        width: 1.35rem;
        height: 1.35rem;
    }
</style>
